<template>
  <router-link :to="page" class="f-box">
    <div class="img-box">
      <img :src="require(`@/assets/features/${icon}`)" alt="" />
    </div>
    <h5>{{ title }}</h5>
    <p>{{ description }}</p>
  </router-link>
</template>

<script>
export default {
  name: "FeatureComponent",
  props: {
    icon: String,
    title: String,
    description: String,
    page: String,
  },
};
</script>

<style scoped>
img {
  width: 30px;
  height: 30px;
}
p {
  font-weight: 400;
  font-size: 14px;
  color: #6f8ba4;
  letter-spacing: 0.88px;
  line-height: 26px;
  position: relative;
  z-index: 2;
  -webkit-transition: all 0.3s ease 0s;
  -moz-transition: all 0.3s ease 0s;
  -o-transition: all 0.3s ease 0s;
  transition: all 0.3s ease 0s;
  margin-bottom: 20px;
}
h5 {
  font-weight: 400;
  font-size: 16px;
  color: #3b566e;
  letter-spacing: 0.7px;
  margin-bottom: 15px;
  position: relative;
  z-index: 2;
}
.img-box {
  width: 67px;
  height: 67px;
  line-height: 70px;
  margin: auto;
  margin-bottom: auto;
  position: relative;
  margin-bottom: 20px;
  background: rgba(var(--s-color), 0.1);
  border-radius: 22px 5px 22px 5px;
  display: flex;
  justify-content: center;
  align-items: center;
}

.f-box:hover .img-box {
  background-color: white;
}
.f-box:hover h5,
.f-box:hover p {
  color: white;
}
.f-box:hover {
  background: rgb(var(--s-color));
}
.f-box {
  display: block;
  background: #ffffff;
  box-shadow: 0 2px 48px 0 rgba(var(--m-color), 0.1);
  border-radius: 40px 5px 40px 5px;
  padding: 30px;
  text-align: center;
  position: relative;
  overflow: hidden;
}
</style>
